.presence {
  margin-left: 8px;
  margin-right: 8px;
  flex-shrink: 0;
}

.menuButton {
  min-width: 32px;
  padding-right: 8px;
  flex-shrink: 0;
}

.breadcrumbs {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
